import type { Dayjs } from "dayjs";
import type { RRule } from "rrule";

import type { Currency, Group, Tax } from "@/types/transaction";
import type { Balance, Ledger } from "@/types/account";

export type TransactionProperties = {
  amount: number;
  applyToIncomeTax: boolean;
  currency: Currency;
  date: Dayjs;
  description: string;
  id?: number;
  isDisabled: boolean;
  group: Group | null;
  ledger: Ledger;
  name: string;
  recurrence: RRule | null;
  settlesReservation?: string | null;
  tax: Tax | null;
};

export default class Transaction {
  amount: number;
  applyToIncomeTax: boolean;
  balance?: Balance;
  currency: Currency;
  date: Dayjs;
  description: string;
  id?: number;
  isDisabled: boolean;
  group: Group | null;
  ledger: Ledger;
  name: string;
  recurrence: RRule | null;
  settlesReservation: string | null;
  tax: Tax | null;
  // Base default so `type` is always set on an instance; Expense/Income override it.
  type: "expense" | "income" = "expense";

  constructor(properties: TransactionProperties) {
    this.amount = properties.amount;
    this.applyToIncomeTax = properties.applyToIncomeTax;
    this.currency = properties.currency;
    this.date = properties.date;
    this.description = properties.description;
    this.id = properties.id;
    this.isDisabled = properties.isDisabled;
    this.group = properties.group;
    this.ledger = properties.ledger;
    this.name = properties.name;
    this.recurrence = properties.recurrence;
    this.settlesReservation = properties.settlesReservation ?? null;
    this.tax = properties.tax;
  }
}
